import { useStore } from "@/hooks/useStore";
import type { Locale } from "@/i18n/i18n-config";
import { GROVER_BASE_URL } from "@/modules/config";
import { useLocale, useTranslations } from "next-intl";

export const getCopyright = () => {
  return `Grover Group GmbH © ${new Date().getFullYear()}`;
};

export const useFooterLinks = () => {
  const t = useTranslations("link.href");
  const locale = useLocale() as Locale;
  const { correlatedMainstore } = useStore();

  return [
    {
      text: "privacy_policy",
      url: `${GROVER_BASE_URL}/${correlatedMainstore}-${locale}${t("privacy_policy")}`,
    },
    {
      text: "terms_and_conditions",
      url: `${GROVER_BASE_URL}/${correlatedMainstore}-${locale}${t("terms_and_conditions")}`,
    },
    {
      text: "imprint",
      url: `${GROVER_BASE_URL}/${correlatedMainstore}-${locale}${t("imprint")}`,
    },
  ];
};
